import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { BookingInvitationResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A booking's OUTGOING pending court invitations (GET /facilities/{facilityId}/
 * bookings/{bookingId}/invitations), host-scoped.
 *
 * Returned VERBATIM as BookingInvitationResponse objects (the backend orders +
 * authorizes the list). The host-only InviteParticipantDialog reads this to build
 * its exclusion set — an already-pending invitee can't be re-invited (the create
 * would 409). A create mutation invalidates `booking.invitations(...)` so the set
 * re-reads the server's truth. `enabled` gates the fetch on a known facility +
 * booking id and (typically) the host context.
 */
export function useBookingInvitations(
  facilityId: string | undefined,
  bookingId: string | undefined,
  enabled = true,
) {
  return useQuery<BookingInvitationResponse[]>({
    queryKey: queryKeys.booking.invitations(facilityId ?? "", bookingId ?? ""),
    queryFn: () =>
      facilityApi.listBookingInvitations(
        facilityId as string,
        bookingId as string,
      ),
    enabled: enabled && Boolean(facilityId) && Boolean(bookingId),
  });
}
